export const environment = {
  production: false,
  staging: true,
  appVersion: 'v0.1.0',
  USERDATA_KEY: 'authf649fc9a5f55',
  apiUrl: 'https://dev-sabico-api.roommatik.com/api/v1',
  // Identity provider (OIDC). Provider-agnostic naming per the concealment policy.
  // The portal has NO local login: an empty `url` only disables the redirect and
  // shows a "not configured" notice on the login page.
  auth: {
    url: 'https://auth.roommatik.com',
    realm: 'roommatik',
    clientId: 'sabico-portal',
    portalUrl: 'https://auth.roommatik.com/realms/roommatik/account',
  },
};
